import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-com',
  templateUrl: './footer.com.html',
  styleUrls: ['footer.scss']
})

export class FooterComponent {}



// WEBPACK FOOTER //
// ./src/app/com/footer/footer.com.ts